export const LOGIN = 'auth/login';
export const LOGIN_WITH_GOOGLE = 'auth/google';
export const LOGIN_WITH_APPLE = 'auth/apple';
export const ANONYMOUS_USER = 'auth/anonymous';
export const DELETE_ACCOUNT = 'auth/delete';
export const REGISTER = 'auth/register';
export const LOGOUT = 'auth/logout';
export const VERIFY_EMAIL = 'auth/verify-email';
export const RESEND_CODE = 'auth/resend-code';
export const FORGOT_PASSWORD = 'auth/forgot-password';
export const RESET_PASSWORD = 'auth/reset-password';
export const ASSESSMENT_QUESTIONS = 'assessments/questions'; 
export const REQUEST_NEW_ASSESSMENT = 'assessments/request'; 
export const SUBMIT_ANSWER = 'users/answers';
export const USER_ANSWERS = 'users/answers';
export const FINALIZE_USER_RESULT = 'users/result';
export const USER_RESULT = 'users/result';
export const USER_PROFILE = 'users';
export const USER_PROGRESS = 'users/progress';
export const PROMPTS = "prompts";
export const PROMPT_DETAILS = "prompts/:promptID";
export const GET_RANDOM_PROMPT_ID = "prompts/random/id";
export const PROMPT_CATEGORIES = "prompts/categories";
export const PROMPT_DATA_MODALS = "prompts/dataModals";
export const REACT_DATA_MODALS = "prompts/dataModals/:id/react";
export const REACT_TO_PROMPT = "prompts/:promptID/react";
export const GET_USER_REACTION = "prompts/:promptID/reactions";
export const FAVOURITE_PROMPT = "prompts/:promptID/favourite";
export const SEEN_PROMPTS = '/prompts/seen';
export const SEEN_PROMPT_IDS = '/prompts/seen/ids';
export const PROMPTS_SUMMARY = '/prompts/summary';
export const UNSEEN_PROMPTS = '/prompts/unseen';
export const FAVOURITE_PROMPTS = '/prompts/favourite';
export const REPORT_ISSUE = 'support/report';
export const SUBMIT_FEEDBACK = 'feedback';
export const CHECK_USER_FEEDBACK = 'feedback/check';
export const PROFILE_SUMMARY = 'users/me/summary';
export const PERSONALITY_DASHBOARD = 'profile-dashboards/dashboard';
export const LEADERS = 'leaders';
export const LEADER_DETAIL = 'leaders/:leaderId';

// Leader insight APIs (under /leaders)
export const LEADER_INSIGHT_PROMPTS = 'leaders/:leaderID/prompts';
export const LEADER_INSIGHT_PROMPT_DETAIL = 'leaders/:leaderID/prompts/:promptID';
export const LEADER_INSIGHT_DATA_MODALS = 'leaders/dataModals';
export const REACT_LEADER_INSIGHT_DATA_MODAL = 'leaders/dataModals/:id/react';
export const FAVOURITE_LEADER_INSIGHT_PROMPT = 'leaders/:leaderID/prompts/:promptID/favourite';
export const MARK_LEADER_INSIGHT_SEEN = 'leaders/:leaderID/prompts/:promptID/seen';